class CtmBefaft extends HTMLElement {
  constructor() {
    super();
    this.frame = this.querySelector('.ctm-befaft__frame');
    this.compare = this.querySelector('.ctm-befaft__compare');
    this.range = this.querySelector('.ctm-befaft__range');
    this.divider = this.querySelector('.ctm-befaft__divider');
    this.handle = this.querySelector('.ctm-befaft__handle');
    this.status = this.querySelector('.ctm-befaft__status');
    this.dragging = false;
    this.initialized = false;
    this.onPointerMove = this.onPointerMove.bind(this);
    this.stopDrag = this.stopDrag.bind(this);
    this.onResize = this.onResize.bind(this);
  }

  connectedCallback() {
    if (this.initialized || !this.frame || !this.range || !this.compare) return;

    this.syncPosition(parseFloat(this.range.value || '50'));
    this.bindEvents();
    this.initialized = true;
  }

  disconnectedCallback() {
    window.removeEventListener('resize', this.onResize);
    this.stopDrag();
  }

  bindEvents() {
    this.range.addEventListener('input', (event) => {
      this.syncPosition(parseFloat(event.target.value || '50'), true);
    });

    this.range.addEventListener('change', (event) => {
      this.syncPosition(parseFloat(event.target.value || '50'), true);
    });

    const dragStartTarget = this.handle || this.divider;
    if (dragStartTarget) {
      dragStartTarget.addEventListener('pointerdown', (event) => {
        event.preventDefault();
        event.stopPropagation();
        this.dragging = true;
        dragStartTarget.setPointerCapture?.(event.pointerId);
        this.updateFromClientX(event.clientX, true);
        window.addEventListener('pointermove', this.onPointerMove);
        window.addEventListener('pointerup', this.stopDrag);
        window.addEventListener('pointercancel', this.stopDrag);
      });
    }

    if (this.frame) {
      this.frame.addEventListener('click', (event) => {
        if (this.dragging) return;
        this.updateFromClientX(event.clientX, true);
      });
    }

    window.addEventListener('resize', this.onResize);
  }

  onPointerMove(event) {
    if (!this.dragging) return;
    this.updateFromClientX(event.clientX, true);
  }

  stopDrag() {
    if (!this.dragging) return;
    this.dragging = false;
    window.removeEventListener('pointermove', this.onPointerMove);
    window.removeEventListener('pointerup', this.stopDrag);
    window.removeEventListener('pointercancel', this.stopDrag);
  }

  onResize() {
    this.syncPosition(parseFloat(this.range.value || '50'));
  }

  syncPosition(value, announce = false) {
    const safeValue = Math.max(0, Math.min(100, Number.isFinite(value) ? value : 50));
    this.compare.style.setProperty('--ctm-befaft-position', `${safeValue}%`);
    this.range.value = safeValue;
    this.range.setAttribute('aria-valuenow', String(safeValue));
    this.range.setAttribute('aria-valuetext', `Comparison position ${Math.round(safeValue)}%`);

    if (announce && this.status) {
      this.status.textContent = `Comparison position ${Math.round(safeValue)}%`;
    }
  }

  updateFromClientX(clientX, announce = false) {
    if (!this.frame) return;
    const rect = this.frame.getBoundingClientRect();
    if (!rect.width) return;
    const nextValue = ((clientX - rect.left) / rect.width) * 100;
    this.syncPosition(nextValue, announce);
  }
}

if (!customElements.get('ctm-befaft')) {
  customElements.define('ctm-befaft', CtmBefaft);
}
